<template>
  <button
    v-bind="$attrs"
    :class="{ loading: loading }"
    :disabled="loading || $attrs.disabled"
  >
    <img
      v-if="loading"
      class="loading"
      alt="Carregando..."
      src="@/assets/tangram-loading.svg"
    />
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: "TangramButton",
  inheritAttrs: false,
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
}

button {
  padding: 8px 16px;
  border-radius: 2px;
  transition-duration: 150ms;
  width: auto;
  border: none;
  outline: none;
  background: #19c1ce;

  img.loading {
    width: 24px;
    height: 24px;
    animation: rotate 1s linear infinite;
  }

  &:disabled,
  &:disabled:hover,
  &:disabled:focus,
  &:disabled:active {
    background: #eef0f2;
  }

  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
  }

  &:hover,
  &:focus,
  &:active,
  &.loading,
  &.loading:hover,
  &.loading:focus,
  &.loading:active {
    background: #11a7b6;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
